module.exports = "<table class=\"table\">\n  <thead>\n    <tr>\n      <th>Názov</th>\n      <th>Adresa</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat=\"row in source.result\">\n      <td><a ui-sref=\"zakaznik-view({id: row.id})\">{{row.nazov}}</a></td>\n      <td>{{row.adresa}}</td>\n    </tr>\n  </tbody>\n</table>"


//////////////////
// WEBPACK FOOTER
// ./src/zakaznici/zakaznik.list.table.html
// module id = 443
// module chunks = 0